import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import BaseForm from '../BaseForm';

import useFetchAll from '../../hooks/useFetchAll';

import {
  fetchAllEmployees,
  updateDealer,
  updateUserEmail,
  updateUserStatus,
  updateUserRole,
  updateUserData,
  addNewUser
} from '../../store/actions';

import {
  REQUIRED,
  ALPHABETICAL,
  EMAIL,
  PHONE
} from '../../utils/formValidation';

import './index.css';

const ProfileDetails = (props) => {
  const [initialData, setInitialData] = useState(null);

  useFetchAll({
    condition: !props.employeeList.length, 
    action: () => props.fetchAllEmployees().then(res => 
      setInitialData(res.find(emp => emp.UUID === localStorage.getItem('userUUID')))
    )
  });

  useEffect(() => {
    props.employeeList.length &&
      setInitialData(props.employeeList.find(emp => emp.UUID === localStorage.getItem('userUUID')))
  }, []);

  const formData = [
    {
      name: 'firstName',
      labelName: 'First Name',
      type: 'text',
      validation: [REQUIRED, ALPHABETICAL]
    },
    {
      name: 'lastName',
      labelName: 'Last Name',
      type: 'text',
      validation: [REQUIRED, ALPHABETICAL]
    },
    {
      name: 'email',
      labelName: 'Email',
      type: 'text',
      validation: [REQUIRED, EMAIL]
    },
    {
      name: 'phone',
      labelName: 'Phone',
      type: 'text',
      validation: [REQUIRED, PHONE]
    },
    {
      name: 'address',
      labelName: 'Street Address',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'zip',
      labelName: 'Zip',
      type: 'text',
      validation: [REQUIRED]
    }
  ]

  const actionsData = {
    email: data => props.updateUserEmail(localStorage.getItem('userUUID'), data.email),
    other: data => props.updateUserData(localStorage.getItem('userUUID'), {
      firstName: data.firstName,
      lastName: data.lastName,
      phone: data.phone,
      address: data.address,
      zip: data.zip,
    }),
  }

  return (
    <BaseForm 
      title="Details"
      formData={formData}
      initialData={initialData}
      actionsData={actionsData}
    />
  );
}

const mapStateToProps = ({
  employees: {
    employeeList
  }
}) => ({
  employeeList
})

export default connect(
  mapStateToProps,
  {
    fetchAllEmployees,
    updateDealer,
    updateUserEmail,
    updateUserStatus,
    updateUserRole,
    updateUserData,
    addNewUser
  }
)(ProfileDetails);